<template>
  <div class="card_ngo bg-white">
    <div>
      <img src="http://backend.ngo.gov.sy/storage/images/logo/default.png" alt="logo">
    </div>
    <div class="name_ngo">
      <h3>{{ name_ngo }}</h3>
      <span>{{ governorate }}</span>
    </div>
    <router-link
      :to="{
        name: 'ngo-home',
        params: { id: id },
      }"
      class="rm"
    >
      <div class="display_ngo"><h3>عرض معلومات المنظمة</h3></div>
    </router-link>
  </div>
</template>

<script>
export default {
  props: ["id", "name_ngo", "governorate"],
  data: () => {
    return {
      windowWidth: window.innerWidth,
    };
  },
};
</script>

<style lang="scss">
.card_ngo {
  transition: all ease-in-out 0.3s;
  -webkit-transition: all ease-in-out 0.3s;
  box-shadow: 0px 5px 15px 0 rgb(0 0 0 / 7%);
  margin-bottom: 15px;
  height: 225px;
  width: 250px;
  border-radius: 11px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  padding: 20px;
  padding-bottom: 0px;
  text-align: center;
  img {
    max-width: 85px;
  }
  .name_ngo {
    margin-bottom: 10px;
    margin-top: 10px;
    h3 {
      font-size: 20px;
    }
  }
  .display_ngo {
    border-radius: 12px;
    padding: 10px;
    padding-left: 20px;
    padding-right: 20px;
    color: white;
    background-color: var(--primary);
    cursor: pointer;
    opacity: 0;
    h3 {
      font-size: 10px;
      color: #fff;
    }
  }
  &:hover {
    padding-bottom: 30px;
  }
}
.card_ngo:hover .display_ngo {
  opacity: 1;
  transition: all ease-in-out 0.3s;
}

@media (max-width: 481px) {
  .card_ngo {
    height: 180px;
    max-width: 145px;
    margin: 2px;
    padding: 15px;

    img {
      max-width: 50px;
    }
    .name_ngo {
      margin-bottom: 10px;
      margin-top: 10px;
      h3 {
        font-size: 11px;
      }
    }
    .display_ngo {
      padding: 5px;
      h3 {
        font-size: 10px;
        color: #fff;
      }
    }
    &:hover {
      padding-bottom: 30px;
    }
  }
}
</style>